import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  DeleteUsersEmailsWrapper,
} from './DeleteTestModal.styles';
import Button from '@atoms/Button';
import Text from '@atoms/Text';
import {ITest} from '@types';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '@store';
import {tests, deleteTests} from '@store/slices/tests';

interface Props {
  isOpened: boolean;
  testsIds: number[];
  onCloseRequest: () => void;
}

const DeleteTestModal: FC<Props> = ({isOpened, onCloseRequest, testsIds}) => {
  const dispatch = useDispatch<AppDispatch>();
  const testsArr: ITest[] = useSelector(tests);

  const DeleteTest = () => {
    dispatch(deleteTests(testsIds));
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader
          title={testsIds.length < 2 ? 'Удалить тест' : 'Удалить тесты'}
          onClose={onCloseRequest}
        />
        <ModalContent>
          <DeleteUsersEmailsWrapper>
            <Text
              text={`Вы уверены, что хотите удалить тест${testsIds.length < 2 ? '' : 'ы'} `}
              display="inline"
            />
            {!!testsIds.length &&
              testsIds.map((testId, idx) => {
                return (
                  <Text
                    key={`delete-test-${testId}`}
                    text={`${idx > 0 ? ',' : ''}
                      ${
                        testsArr.find(test => {
                          return test.id === testId;
                        })?.name || ''
                      }`}
                    type="bodyM"
                    display="inline"
                  />
                );
              })}
            <Text text="?" display="inline" />
            <Text text="Это действие необратимо." />
          </DeleteUsersEmailsWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title="Удалить"
            variant="filled"
            redButton
            onClick={DeleteTest}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default DeleteTestModal;
